import React from 'react';
import { MapPin, Mail, Phone, ExternalLink } from 'lucide-react';

const Footer = () => {
  const airbnbListingUrl = "https://www.airbnb.co.uk/rooms/10280192";

  return (
    <footer className="bg-primary/5 border-t border-border/50">
      <div className="max-w-6xl mx-auto px-6 py-12">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-10">
          {/* Logo & Description */}
          <div className="md:col-span-1">
            <img 
              src="/images/hayloft-logo-new.png" 
              alt="The Hayloft" 
              className="h-24 w-auto mb-4"
            />
            <p className="text-sm text-muted-foreground leading-relaxed">
              A peaceful countryside retreat in the heart of West Sussex, just 15 minutes from Gatwick Airport.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="font-semibold text-foreground mb-4">Quick Links</h3>
            <ul className="space-y-3">
              <li>
                <a 
                  href={airbnbListingUrl}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-sm text-muted-foreground hover:text-primary transition-colors flex items-center gap-2"
                  onClick={() => { if (window.va) window.va('event', { name: 'airbnb_click', data: { location: 'footer_book' } }); }}
                >
                  Book on Airbnb
                  <ExternalLink className="w-3 h-3" />
                </a>
              </li>
              <li>
                <a href="#booking-section" className="text-sm text-muted-foreground hover:text-primary transition-colors">
                  Check Availability
                </a>
              </li>
              <li>
                <a href="#" className="text-sm text-muted-foreground hover:text-primary transition-colors">
                  View Gallery
                </a>
              </li>
              <li>
                <a href="#" className="text-sm text-muted-foreground hover:text-primary transition-colors">
                  Guest Reviews
                </a>
              </li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h3 className="font-semibold text-foreground mb-4">Location</h3>
            <div className="space-y-3">
              <div className="flex items-start gap-3 text-sm text-muted-foreground">
                <MapPin className="w-4 h-4 mt-0.5 flex-shrink-0" />
                <span>Balcombe, West Sussex<br />United Kingdom, RH17</span>
              </div>
            </div>
          </div>
        </div>

        {/* Bottom bar */}
        <div className="mt-10 pt-6 border-t border-border/50 flex flex-col items-center gap-4">
          <p className="text-xs text-muted-foreground text-center">
            © {new Date().getFullYear()} The Hayloft. All bookings handled securely through Airbnb.
          </p>
          <a 
            href="https://www.wssolutions.uk" 
            target="_blank" 
            rel="noopener noreferrer"
            className="flex items-center justify-center gap-1 text-xs px-8 py-4 -mx-8 -mb-4 cursor-pointer transition-opacity duration-200 hover:opacity-60"
          >
            <span className="text-muted-foreground">Web design by</span>
            <span style={{ fontFamily: "'DM Serif Display', serif", color: '#00475B' }}>
              WS Solutions
            </span>
          </a>
        </div>
      </div>
    </footer>
  );
};

export default Footer;